module.exports = __webpack_public_path__ + "static/img/dataBookManage.bea55ff0.png";